import Select from "react-select";

export const SelectItem = ({ defaultValue, setFieldValue, items, values, type }) => {
  const normalizedItems = Array.isArray(items)
    ? items
    : Array.isArray(items?.results)
    ? items.results
    : [];
  const labels = normalizedItems.filter((item) => item.id == values[`${type}Id`]);
  const label = labels.length ? labels[0].name : "";
  return (
    <Select
      classNamePrefix="react-select"
      id={type}
      type="text"
      defaultValue={defaultValue}
      onChange={(option) => {
        setFieldValue(`${type}Id`, option.value);
      }}
      options={normalizedItems.map((item) => ({
        value: item.id,
        label: item.name,
      }))}
      isMulti={false}
      value={{
        value: values[`${type}Id`] || "",
        label: label,
      }}
    />
  );
};
